export const SPORTCLOUD_LOGO = "assets/icon/logo_quer.png";
export const AVATAR_LOGO = "assets/images/avatar.png";
